// faq accordian js
$(document).ready(function() {
  function faqAccordion() {
    let $accoHeadings = $('.faq-accordian .acc-block-wrap .acco-head');
    console.log("$accoHeadings :: ",$accoHeadings);
    $accoHeadings.off('click').on('click', function() {
      let $selectHeading = $(this);
      let $selectedContent = $selectHeading.next();

      $accoHeadings.not($selectHeading).each(function() {
        let $otherContent = $(this).next(); 
        if ($otherContent.is(':visible')) {
          $otherContent.slideUp();
          $(this).removeClass('active');
        }
      });
      $selectedContent.slideToggle();
      $selectHeading.toggleClass('active');
    });
  }
  faqAccordion();
  $(window).resize(function() {
  });
});



 $('.responsive').slick({
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});



// For Account page
$(function() {
  $('a.my-order-block').click(function(event) {
    const stickyHeader = document.querySelector('sticky-header');
    const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
    const height = headerHeight;
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top - height
    }, 1000);
  });
});



$(function() {
  $('a.account-info').click(function(event) {
    const cst_Header = document.querySelector('sticky-header');
    const cst_headerHeight = cst_Header ? cst_Header.offsetHeight : 0;
    const cst_height = cst_headerHeight;
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top - cst_height
    }, 1000);
  });
});

